import { useRef } from "react";

import PropTypes from "prop-types";

import ActionPopOutOption from "@/view/ActionPopOutOption";
import SubMenu from "./SubMenu";

const propTypes = {
  actionName: PropTypes.string.isRequired,
  activeSubMenu: PropTypes.string,
  dataProps: PropTypes.object,
  eventProperties: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  popOutContents: PropTypes.node.isRequired,
  setActiveSubMenu: PropTypes.func.isRequired,
  showLockIcon: PropTypes.bool,
  title: PropTypes.string,
};

const ActionPopOutOptionWithSubMenu = ({
  actionName,
  activeSubMenu,
  dataProps = {},
  disabled,
  eventProperties,
  icon,
  popOutContents,
  setActiveSubMenu,
  showLockIcon,
  title,
}) => {
  const ref = useRef(null);

  const subMenuIsActive = activeSubMenu === actionName;
  const shouldNotRender = activeSubMenu && !subMenuIsActive;

  if (shouldNotRender) return null;

  const handleBackClick = async () => {
    // Waiting for the state to update so the button
    // we want to focus is rendered
    await setActiveSubMenu(null);

    // TODO - the focus call below is currently not working
    // but will be revisited in a follow-up a11y ticket
    ref?.current?.focus();
  };

  if (subMenuIsActive) {
    return (
      <SubMenu
        headerText={title ?? actionName}
        onBackClick={handleBackClick}
        menuItems={popOutContents}
      />
    );
  }

  return (
    <ActionPopOutOption
      dataProps={dataProps}
      eventProperties={eventProperties}
      disabled={disabled}
      hasSubMenu
      icon={icon}
      onClick={() => setActiveSubMenu(actionName)}
      ref={ref}
      showLockIcon={showLockIcon}
      subMenuIsActive={subMenuIsActive}
      title={title ?? actionName}
    />
  );
};

ActionPopOutOptionWithSubMenu.propTypes = propTypes;

export default ActionPopOutOptionWithSubMenu;
